import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, useEffect, useState } from 'react';
import { classNames } from '../../helpers/classNames';
import OptionInterface from '../../interfaces/OptionInterface';
import styles from './style.module.scss';

interface Props {
    name: string;
    label: string;
    value?: string;
    options: OptionInterface[];
    placeholder?: string;
    onChange?: (param: any) => void;
    onSelect?: (param: any) => void;
    isDisabled?: boolean;
    isRequired?: boolean;
    icon?: IconProp;
}

function Select(props: Props) {
    const {
        label,
        name,
        value = '',
        placeholder = '',
        options,
        onSelect,
        onChange,
        isDisabled,
        icon,
    } = props;
    const [selectedValue, setSelectedValue] = useState('');
    useEffect(() => {
        setSelectedValue(value);
    }, [value]);
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setSelectedValue(value);
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <div className={styles.divSelect}>
            <label className={styles.labelSelect}>{label}</label>
            {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
            <select
                name={name}
                value={selectedValue}
                className={classNames([
                    styles.select,
                    icon ? styles.inputIcon : '',
                ])}
                disabled={isDisabled}
                onChange={handleChange}
            >
                <option disabled value="" className={styles.placeholder}>
                    {placeholder}
                </option>
                {options?.map((option: OptionInterface) => (
                    <option
                        key={name + option.name + option.label}
                        value={option.id || option.name}
                        onSelect={onSelect}
                    >
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default Select;
